import React from 'react'
import Contact from '../components/contact/Contact'
import Footer from '../components/footer/Footer'
import Navbar from '../components/navbar/Navbar'

const ContactPage = () => {
    return (
        <>
            <Navbar/>
            <Contact />
            <Footer />   
        </>
    )
}

export default ContactPage
